import { useCallback, useSyncExternalStore } from "react"

/** From this width (1024px) a page puts panels side by side; below it, they become tabs. */
const WIDE_QUERY = "(min-width: 64rem)"

/** True while `query` matches. `fallback` stands where there is no matchMedia (jsdom). */
export function useMedia(query: string, fallback = false) {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (typeof window.matchMedia !== "function") return () => {}
      const list = window.matchMedia(query)
      list.addEventListener("change", onChange)
      return () => list.removeEventListener("change", onChange)
    },
    [query],
  )
  return useSyncExternalStore(
    subscribe,
    () => (typeof window.matchMedia === "function" ? window.matchMedia(query).matches : fallback),
    () => fallback,
  )
}

/** True from 1024px. */
export function useWide() {
  return useMedia(WIDE_QUERY)
}
